import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { userCompanyDetails } from "../../Services/ApiCalling/profile";

export const userAccess = createAsyncThunk("userAccess/get", async (token) => {
  try {
  } catch (err) {}
});

export const fetchCompanyDetails = createAsyncThunk(
  "companyDetails/fetch",
  async (companyId, { rejectWithValue }) => {
    try {
      let data = await userCompanyDetails();
      return { companyDetails: data };
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Error fetching company details"
      );
    }
  }
);

const profileSlice = createSlice({
  name: "profile",
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(userAccess.pending, (state) => {})
      .addCase(userAccess.fulfilled, (state, action) => {
        state.userAccess = action.payload?.user?.data?.data;
      })
      .addCase(userAccess.rejected, (state, action) => {});

    builder
      .addCase(fetchCompanyDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanyDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.companyDetails = action.payload.companyDetails?.data || null;
      })
      .addCase(fetchCompanyDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default profileSlice.reducer;
